import './style.css';

export const BackWaves = () => {

   return (
      <div className="back"></div>
   );
};